<template>
  <hm-content title="促销列表">
    <div slot="header">
      <hm-step :steps="steps" :step="1" disabledNext></hm-step>
    </div>
    <ul class="activity-lists flex flex-wrap  flex-start">
      <li v-for="(v, i) in activityCategoryList" :key="i">
        <div class="activity-name" :class="{ active: parentId === v.treeId }">
          {{ v.typeName }}

        </div>
        <div class="flex flex-between" v-if="v.nodes.length>=2">
          <div v-for="(item, index) in v.nodes"
            :key="index"
            class="flex activity-category"
            :class="[{ activeBox: childId === item.treeId },{mr20:index !== v.nodes.length - 1}]"
            @click="nextStep(item)"
            >
            <div class="img-wrapper">
              <img :src="item.logoPath" alt="" />
            </div>
            <div
                class="category flex item-center p10"
                :class="{ active: childId === item.treeId }"
                >{{ item.typeName }}</div
              >
          </div>
        </div>
        <div v-else @click="nextStep(item)" class="flex flex-center activity-category"  style="width:100%" v-for="(item, index) in v.nodes"
            :key="index">
          <div class="img-wrapper">
              <img :src="item.logoPath" alt="" />
          </div>
          <div
            class="category flex item-center p10"
            :class="{ active: childId === item.treeId }"
            >{{ item.typeName }}
            </div>

        </div>
      </li>
    </ul>
    <ul class="activity-list flex flex-wrap" v-if="false">
      <li v-for="(v, i) in activityCategoryList" :key="i">
        <div class="img-wrapper">
          <img :src="v.logoPath" alt="" />
        </div>
        <div class="activity-name" :class="{ active: parentId === v.treeId }">
          {{ v.typeName }}
        </div>
        <div class="activity-category flex flex-center">
          <div
            @click="nextStep(item)"
            class="flex flex-between category-name"
            v-for="(item, index) in v.nodes"
            :key="index"
          >
            <span
              class="category"
              :class="{ active: childId === item.treeId }"
              >{{ item.typeName }}</span
            >
            <div class="line" v-if="index !== v.nodes.length - 1">/</div>
          </div>
        </div>
      </li>
    </ul>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import { mapGetters } from "vuex";
import { setCookie, getCookie, removeCookie } from "../../utils/utils";
export default {
  data() {
    return {
      parentId: "",
      childId: "",
      steps: [
        {
          link: "SelectActivity",
          name: "选择促销类型"
        },
        {
          link: "CreatActivity",
          name: "创建促销"
        },
        {
          link: "GoodsManagement",
          name: "管理促销商品"
        },
        {
          link: "CreatGoodsRule",
          name: "创建规则"
        }
      ]
    };
  },
  computed: mapGetters(["activityCategoryList"]),
  created() {},
  mounted() {
    this.$store.dispatch("queryActivityCategoryList");
    const steps = getCookie({ key: "STEP" });
    if (steps && steps.hasOwnProperty("step1")) {
      this.parentId = steps.step1.parentId;
      this.childId = steps.step1.childId;
    }
  },
  watch: {},
  methods: {
    nextStep(row) {
      let steps = getCookie({ key: "STEP" }) || {};
      if (!steps.hasOwnProperty("step1")) {
        steps.step1 = {
          parentId: row.parentId,
          childId: row.treeId
        };
        setCookie({
          key: "STEP",
          data: steps
        });
        this.$router.push({
          name: "CreatActivity"
        });
      } else {
        if (steps.step1.childId !== row.treeId) {
          this.$confirm(
            "当前已有活动，切换活动会删除添加活动内容，是否删除?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          ).then(() => {
            removeCookie({ key: "STEP" });
            steps = {};
            steps.step1 = {
              parentId: row.parentId,
              childId: row.treeId
            };
            setCookie({
              key: "STEP",
              data: steps
            });
            this.$router.push({
              name: "CreatActivity"
            });
          });
        } else {
          this.$router.push({
            name: "CreatActivity"
          });
        }
      }
    }
  },
  components: {
    HmStep
  }
};
</script>

<style scoped lang="scss">
.activity-lists {
  padding: 20px;

  li {
    box-sizing: border-box;
    box-shadow: 0px 0px 50px 0px #f4f4f4;
    width: 450px;
    padding: 20px;
    transition: all linear 0.2s;
    user-select: none;
    margin: 10px 10px 10px 0;
  }
  .activity-name {
    color: #222;
    margin: 10px 0;
    font-size: 18px;
  }
  li:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 20px;
  }
  .activity-category {
    cursor: pointer;

    border: 1px solid #eeeeee;
    border-radius: 4px;
    // padding: 10px;
    // background: #fff1f7;
    width: 200px;
    border-radius: 4px;
    .category-name {
      font-size: 12px;
    }
  }
  .activeBox {
    box-shadow: 0px 0px 36px 0px #f1f1f1;
    border: 1px solid #dddddd;
  }
  .img-wrapper {
    img {
      width: 70px;
      padding: 10px 0 10px 10px;
    }
  }
  .activity-category:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 20px;
  }
  .activity-name.active,
  .category.active {
    color: #e60e6d !important;
  }
}

.activity-list {
  text-align: center;
  padding: 20px;
  li {
    width: 200px;
    box-sizing: border-box;
    padding: 20px;
    transition: all linear 0.2s;
    user-select: none;
    .line {
      margin: 0 5px;
    }
    .category-name {
      cursor: pointer;
    }
    .category-name:hover {
      .category {
        color: #e60e6d;
      }
    }
  }
  li:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 20px;
  }
  .img-wrapper {
    img {
      width: 70px;
    }
  }

  .activity-name {
    color: #000;
    margin: 10px 0;
    // font-size: 18px;
  }

  .activity-category {
    .category-name {
      font-size: 12px;
    }
  }
  .activity-name.active,
  .category.active {
    color: #e60e6d !important;
  }
}
</style>
